import { ActivityTableRow_ActivityFragment } from 'generated/graphql'

type TGetRegionsText = (
  regionDistricts: ActivityTableRow_ActivityFragment['regionDistricts'],
  regions: ActivityTableRow_ActivityFragment['regions'],
) => string

/**
 * @desc 지역구, 지역을 텍스트로 변환합니다
 * @desc 지역구가 없을 경우 지역만 표시합니다
 * @desc 지역구가 있을 경우 지역구를 표시합니다
 * @desc 지역구가 없을 경우 지역구를 표시하지 않습니다
 * @param {ActivityTableRow_ActivityFragment['regionDistricts']} regionDistricts - 지역구
 * @param {ActivityTableRow_ActivityFragment['regions']} regions - 지역
 * @returns {string}
 */
export const getRegionsText: TGetRegionsText = (
  regionDistricts,
  regions,
): string => {
  const districtsArr = (regionDistricts ?? []).map(
    (regionDistrict) =>
      `${regionDistrict?.region?.name}-${regionDistrict?.name}`,
  )

  const regionsArr = [
    ...(regions ?? []).map((region) => region?.name),
    ...districtsArr,
  ]

  if (regionsArr.length > 1) {
    return `${regionsArr[0]} 외 ${regionsArr.length - 1}`
  } else if (regionsArr.length === 1 && regionsArr[0]) {
    return regionsArr[0]
  } else {
    return '-'
  }
}
